import type { ReactNode } from "react";
import { Button } from "./souvenir.ts";

// One group of a settings page, the profile's or a trip's (DESIGN.md, "The profile in groups", "Trip settings"): a
// raised card under a small eyebrow heading. The profile's first, me, has no heading to see: its heading is there
// for screen readers only. Hairlines part a card's own parts (`.tm-settings-part`), whose labels
// (`.tm-settings-label`) stay under the group's heading. A danger zone (DESIGN.md, "A danger zone") is the last
// group of its page, its heading and hairline in coral: only for Delete this trip, Leave this trip and Delete my
// account, so coral keeps meaning it.
export function SettingsGroup({
  id,
  title,
  unseen = false,
  danger = false,
  className,
  children,
}: {
  id: string;
  title: string;
  unseen?: boolean;
  danger?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section className={danger ? "tm-settings-group is-danger" : "tm-settings-group"} aria-labelledby={id}>
      <h2 id={id} className={unseen ? "tm-hidden" : "eyebrow tm-muted tm-settings-group-title"}>
        {title}
      </h2>
      <div className={className ? `tm-settings-card ${className}` : "tm-settings-card"}>{children}</div>
    </section>
  );
}

// One action in a danger zone: a line saying what it does, then its coral button; under it, anything more it
// needs to say (where to go instead, what went wrong).
export function DangerAction({
  what,
  action,
  disabled = false,
  onClick,
  children,
}: {
  what: ReactNode;
  action: string;
  disabled?: boolean;
  onClick: () => void;
  children?: ReactNode;
}) {
  return (
    <div className="tm-settings-part tm-danger-action">
      <p className="caption tm-muted">{what}</p>
      <Button size="sm" className="tm-edge-start tm-danger-button" disabled={disabled} onClick={onClick}>
        {action}
      </Button>
      {children}
    </div>
  );
}
